<template>
    <div>
        <funding-source
            :organization="organization"
            :title="title"
            :fields="fields"
            :patients="patients"
            :therapists="therapists"
            :sourceType="'paid'"
            :invoices="invoices"
            :pagination="pagination"
            :loading="loading"
            @fetch-page="fetchPage($event)"
            @update-invoice="updateInvoice($event)"
            @recover-invoices="recoverInvoices($event)"
            @move-invoices="moveInvoices($event)"
        >
            <slot></slot>
        </funding-source>
    </div>
</template>
<script>
import FundingSource from "./FundingSource";
import { fundingSourceWrapper } from "../../plugins/fundingSourceWrapper";

export default {
    name: "FundingSourcesPaid",
    mixins: [fundingSourceWrapper],
    components: { FundingSource },
};
</script>
